import '../scss/slider.scss';

import Slider from './components/Slider';
import Gallery from './components/Gallery';
import MainSlider from './components/MainSlider';

document.addEventListener('DOMContentLoaded', (event) => {
    Slider.setLogoSlider();
    Slider.setProductDetail();
    Gallery.init();
    Gallery.initNext();
    MainSlider.init();
});